export default __webpack_public_path__ + "static/media/ic_menu_24px.cb2eae4d.svg";